// tslint:disable-next-line:function-name
export function BinaryTree(width, height, nodes) {
    if (!nodes.length) {
        return [];
    }
    var addNodes = nodes.length === 1 ? [] : [0];
    for (var i = 0; i < nodes.length; i += 1) {
        addNodes.push(addNodes[addNodes.length - 1] + nodes[i]);
    }
    function findNeaestNumberInArray(list, num) {
        var targetNum = list[1];
        var minNum = Math.abs(targetNum - num);
        var index = 1;
        for (var i = 2; i < list.length; i += 1) {
            if (Math.abs(list[i] - num) < minNum) {
                targetNum = list[i];
                index = i;
                minNum = Math.abs(list[i] - num);
            }
            else {
                break;
            }
        }
        return [
            targetNum,
            list.slice(0, index + 1),
            list.slice(index).map(function (v) { return v - targetNum; }),
        ];
    }
    function generateTree(rootNum, list) {
        if (list.length >= 2) {
            var max = list[list.length - 1];
            var min = list[0];
            var _a = findNeaestNumberInArray(list, (max + min) / 2), targetNum = _a[0], listLeft = _a[1], listRight = _a[2];
            return {
                value: rootNum,
                left: listLeft.length > 2 ? generateTree(targetNum, listLeft) : { value: targetNum },
                right: listRight.length > 2
                    ? generateTree(rootNum - targetNum, listRight)
                    : { value: rootNum - targetNum },
            };
        }
        if (list.length === 1) {
            return {
                value: rootNum,
            };
        }
        if (list.length === 0) {
            return null;
        }
    }
    function walkTreeFroRects(rect, node) {
        var res = [];
        if (node.left && node.right) {
            var leftB = void 0;
            var rightB = void 0;
            if (rect.width > rect.height) {
                leftB = {
                    width: (node.left.value / node.value) * rect.width || 0,
                    height: rect.height,
                    x: rect.x,
                    y: rect.y,
                };
                rightB = {
                    width: (node.right.value / node.value) * rect.width || 0,
                    height: rect.height,
                    x: rect.x + leftB.width,
                    y: rect.y,
                };
            }
            else {
                leftB = {
                    width: rect.width,
                    height: (node.left.value / node.value) * rect.height || 0,
                    x: rect.x,
                    y: rect.y,
                };
                rightB = {
                    width: rect.width,
                    height: (node.right.value / node.value) * rect.height || 0,
                    x: rect.x,
                    y: rect.y + leftB.height,
                };
            }
            res = res.concat(walkTreeFroRects(leftB, node.left));
            res = res.concat(walkTreeFroRects(rightB, node.right));
            return res;
        }
        return [rect];
    }
    var root = generateTree(addNodes[addNodes.length - 1], addNodes);
    return walkTreeFroRects({
        width: width,
        height: height,
        x: 0,
        y: 0,
    }, root);
}
